/**
 * Cached references to every DOM element the app touches.
 * Resolved once at module load — `<script type="module">` defers execution
 * until after the DOM is parsed, so all selectors must exist.
 */
export const els = {
  mapStatus: document.querySelector<HTMLElement>('#mapStatus')!,
  mapPanel: document.querySelector<HTMLElement>('.map-panel')!,
  countryCount: document.querySelector<HTMLElement>('#countryCount')!,
  cityCount: document.querySelector<HTMLElement>('#cityCount')!,
  photoCount: document.querySelector<HTMLElement>('#photoCount')!,
  selectedCountryTitle: document.querySelector<HTMLElement>(
    '#selectedCountryTitle',
  )!,
  countrySummary: document.querySelector<HTMLElement>('#countrySummary')!,
  visitList: document.querySelector<HTMLElement>('#visitList')!,
  visitCardTemplate: document.querySelector<HTMLTemplateElement>(
    '#visitCardTemplate',
  )!,
  clearButton: document.querySelector<HTMLButtonElement>('#clearButton')!,
  exportButton: document.querySelector<HTMLButtonElement>('#exportButton')!,
  importInput: document.querySelector<HTMLInputElement>('#importInput')!,
  themeLabel: document.querySelector<HTMLElement>('#themeLabel')!,
  languageLabel: document.querySelector<HTMLElement>('#languageLabel')!,
  themeButtons: [
    ...document.querySelectorAll<HTMLButtonElement>('[data-theme-choice]'),
  ],
  languageButtons: [
    ...document.querySelectorAll<HTMLButtonElement>('[data-lang-choice]'),
  ],
  drawer: document.querySelector<HTMLElement>('#drawer')!,
  drawerToggle: document.querySelector<HTMLButtonElement>('#drawerToggle')!,
  topbar: document.querySelector<HTMLElement>('.topbar')!,
}
